module.exports = __webpack_public_path__ + "img/notification-icon.2ee32fb0.svg";